export default "__VITE_ASSET__D0jV_oDU__"